export default __webpack_public_path__ + "static/media/urlAvailable.d94795f9.png";